/**
 * Swiper.js を利用したレスポンシブスライダー制御モジュール
 *
 * - PC幅のみスライダーを有効化し、SP幅では自動的に破棄
 * - Swiperの初期化・破棄をウィンドウリサイズ時にも自動で切り替え
 *
 * @example
 *   const slider = new Slider('.my-slider', { loop: true });
 *
 * 注意:
 * - Swiper.js本体の読み込みが必要
 * - スライダーのラッパーに .swiper クラスが必要
 */
export class Slider {
	constructor(sliderSelector, options = {}) {
		this.sliderSelector = sliderSelector;
		this.options = options;
		this.swiper = null;
		this.initOrDestroy();
		window.addEventListener('resize', () => this.initOrDestroy());
	}

    /**
     * PC/SP幅に応じてSwiperの初期化・破棄を切り替え
     */
	initOrDestroy() {
		const isDesktop = window.innerWidth >= 768; // 例: 768px以上を PC とみなす
		const container = document.querySelector(this.sliderSelector + ' .swiper');
		if (isDesktop) {
			if (!this.swiper && container) {
				this.swiper = new Swiper(container, this.options);
			}
		} else {
			if (this.swiper) {
				this.swiper.destroy(true, true);
				this.swiper = null;
			}
		}
	}
}
